import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-cd895bc6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "card mb-25 border-0 rounded-0 bg-white letter-spacing" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "card-head box-shadow bg-white p-15 p-sm-20 p-md-25" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "row mb-4" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "col-sm-6 col-lg-3" }, [
      /*#__PURE__*/_createElementVNode("div", { class: "card" }, [
        /*#__PURE__*/_createElementVNode("div", { class: "card-body" }, [
          /*#__PURE__*/_createElementVNode("div", { class: "d-flex align-items-center" }, [
            /*#__PURE__*/_createElementVNode("div", { class: "subheader" }, "Emprunts en cours"),
            /*#__PURE__*/_createElementVNode("div", { class: "ms-auto" }, [
              /*#__PURE__*/_createElementVNode("i", { class: "fa fa-clock text-primary fs-4" })
            ])
          ]),
          /*#__PURE__*/_createElementVNode("div", { class: "h1 mb-3" }),
          /*#__PURE__*/_createElementVNode("div", { class: "d-flex mb-2" }, [
            /*#__PURE__*/_createElementVNode("div", { class: "flex-fill" }, [
              /*#__PURE__*/_createElementVNode("div", { class: "progress progress-sm" }, [
                /*#__PURE__*/_createElementVNode("div", {
                  class: "progress-bar bg-primary",
                  style: {"width":"75%"},
                  role: "progressbar"
                })
              ])
            ])
          ])
        ])
      ])
    ]),
    /*#__PURE__*/_createElementVNode("div", { class: "col-sm-6 col-lg-3" }, [
      /*#__PURE__*/_createElementVNode("div", { class: "card" }, [
        /*#__PURE__*/_createElementVNode("div", { class: "card-body" }, [
          /*#__PURE__*/_createElementVNode("div", { class: "d-flex align-items-center" }, [
            /*#__PURE__*/_createElementVNode("div", { class: "subheader" }, "Emprunts terminés"),
            /*#__PURE__*/_createElementVNode("div", { class: "ms-auto" }, [
              /*#__PURE__*/_createElementVNode("i", { class: "fa fa-check-circle text-success fs-4" })
            ])
          ]),
          /*#__PURE__*/_createElementVNode("div", { class: "h1 mb-3" }),
          /*#__PURE__*/_createElementVNode("div", { class: "d-flex mb-2" }, [
            /*#__PURE__*/_createElementVNode("div", { class: "flex-fill" }, [
              /*#__PURE__*/_createElementVNode("div", { class: "progress progress-sm" }, [
                /*#__PURE__*/_createElementVNode("div", {
                  class: "progress-bar bg-success",
                  style: {"width":"100%"},
                  role: "progressbar"
                })
              ])
            ])
          ])
        ])
      ])
    ]),
    /*#__PURE__*/_createElementVNode("div", { class: "col-sm-6 col-lg-3" }, [
      /*#__PURE__*/_createElementVNode("div", { class: "card" }, [
        /*#__PURE__*/_createElementVNode("div", { class: "card-body" }, [
          /*#__PURE__*/_createElementVNode("div", { class: "d-flex align-items-center" }, [
            /*#__PURE__*/_createElementVNode("div", { class: "subheader" }, "En retard"),
            /*#__PURE__*/_createElementVNode("div", { class: "ms-auto" }, [
              /*#__PURE__*/_createElementVNode("i", { class: "fa fa-exclamation-triangle text-danger fs-4" })
            ])
          ]),
          /*#__PURE__*/_createElementVNode("div", { class: "h1 mb-3 text-danger" }),
          /*#__PURE__*/_createElementVNode("div", { class: "d-flex mb-2" }, [
            /*#__PURE__*/_createElementVNode("div", { class: "flex-fill" }, [
              /*#__PURE__*/_createElementVNode("div", { class: "progress progress-sm" }, [
                /*#__PURE__*/_createElementVNode("div", {
                  class: "progress-bar bg-danger",
                  style: {"width":"60%"},
                  role: "progressbar"
                })
              ])
            ])
          ])
        ])
      ])
    ]),
    /*#__PURE__*/_createElementVNode("div", { class: "col-sm-6 col-lg-3" }, [
      /*#__PURE__*/_createElementVNode("div", { class: "card" }, [
        /*#__PURE__*/_createElementVNode("div", { class: "card-body" }, [
          /*#__PURE__*/_createElementVNode("div", { class: "d-flex align-items-center" }, [
            /*#__PURE__*/_createElementVNode("div", { class: "subheader" }, "Total emprunts"),
            /*#__PURE__*/_createElementVNode("div", { class: "ms-auto" }, [
              /*#__PURE__*/_createElementVNode("i", { class: "fa fa-books text-info fs-4" })
            ])
          ]),
          /*#__PURE__*/_createElementVNode("div", { class: "h1 mb-3" }),
          /*#__PURE__*/_createElementVNode("div", { class: "d-flex mb-2" }, [
            /*#__PURE__*/_createElementVNode("div", { class: "flex-fill" }, [
              /*#__PURE__*/_createElementVNode("div", { class: "progress progress-sm" }, [
                /*#__PURE__*/_createElementVNode("div", {
                  class: "progress-bar bg-info",
                  style: {"width":"85%"},
                  role: "progressbar"
                })
              ])
            ])
          ])
        ])
      ])
    ])
  ])
], -1))
const _hoisted_3 = { class: "card-body p-15 p-sm-20 p-md-25" }
const _hoisted_4 = {
  key: 0,
  class: "text-center py-4"
}
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "spinner-border text-primary",
  role: "status"
}, [
  /*#__PURE__*/_createElementVNode("span", { class: "visually-hidden" }, "Chargement...")
], -1))
const _hoisted_6 = [
  _hoisted_5
]
const _hoisted_7 = {
  key: 1,
  class: "text-center py-4"
}
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "alert alert-info" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fa fa-info-circle me-2" }),
  /*#__PURE__*/_createTextVNode(" Aucun emprunt trouvé avec les critères de recherche actuels. ")
], -1))
const _hoisted_9 = [
  _hoisted_8
]
const _hoisted_10 = {
  key: 2,
  class: "table-responsive"
}
const _hoisted_11 = { class: "table table-hover table-striped" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", { class: "table-dark" }, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", null, "Image"),
    /*#__PURE__*/_createElementVNode("th", null, "Document"),
    /*#__PURE__*/_createElementVNode("th", null, "Auteur(s)"),
    /*#__PURE__*/_createElementVNode("th", null, "Catégorie"),
    /*#__PURE__*/_createElementVNode("th", null, "Date début"),
    /*#__PURE__*/_createElementVNode("th", null, "Date fin"),
    /*#__PURE__*/_createElementVNode("th", null, "Statut"),
    /*#__PURE__*/_createElementVNode("th", null, "Jours restants"),
    /*#__PURE__*/_createElementVNode("th", null, "Lire")
  ])
], -1))
const _hoisted_13 = { class: "text-center" }
const _hoisted_14 = ["src", "alt"]
const _hoisted_15 = {
  key: 1,
  class: "bg-light rounded d-flex align-items-center justify-content-center",
  style: {"width":"50px","height":"50px"}
}
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fa fa-book text-muted" }, null, -1))
const _hoisted_17 = [
  _hoisted_16
]
const _hoisted_18 = { class: "fw-bold" }
const _hoisted_19 = { class: "text-muted" }
const _hoisted_20 = { key: 0 }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fa fa-clock me-1" }, null, -1))
const _hoisted_22 = {
  key: 1,
  class: "text-danger fw-bold"
}
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fa fa-exclamation-triangle me-1" }, null, -1))
const _hoisted_24 = {
  key: 2,
  class: "text-success"
}
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fa fa-check-circle me-1" }, null, -1))
const _hoisted_26 = { class: "text-center" }
const _hoisted_27 = ["onClick"]
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fa fa-book-open me-1" }, null, -1))
const _hoisted_29 = {
  key: 1,
  class: "text-muted"
}
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fa fa-lock me-1" }, null, -1))
const _hoisted_31 = {
  key: 3,
  "aria-label": "Navigation des pages",
  class: "mt-4"
}
const _hoisted_32 = { class: "pagination justify-content-center" }
const _hoisted_33 = ["disabled"]
const _hoisted_34 = ["onClick"]
const _hoisted_35 = ["disabled"]
const _hoisted_36 = { class: "text-center text-muted" }
const _hoisted_37 = {
  key: 0,
  class: "modal fade show d-block",
  tabindex: "-1",
  style: {"background-color":"rgba(0,0,0,0.5)"}
}
const _hoisted_38 = { class: "modal-dialog modal-lg" }
const _hoisted_39 = { class: "modal-content" }
const _hoisted_40 = { class: "modal-header" }
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", { class: "modal-title" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fa fa-book me-2" }),
  /*#__PURE__*/_createTextVNode(" Détails de l'emprunt ")
], -1))
const _hoisted_42 = {
  key: 0,
  class: "modal-body"
}
const _hoisted_43 = { class: "card mb-3" }
const _hoisted_44 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "card-header bg-primary text-white" }, [
  /*#__PURE__*/_createElementVNode("h6", { class: "mb-0" }, [
    /*#__PURE__*/_createElementVNode("i", { class: "fa fa-book me-2" }),
    /*#__PURE__*/_createTextVNode(" Informations du document ")
  ])
], -1))
const _hoisted_45 = { class: "card-body" }
const _hoisted_46 = { class: "row" }
const _hoisted_47 = { class: "col-md-8" }
const _hoisted_48 = { class: "text-muted mb-2" }
const _hoisted_49 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Auteur(s):", -1))
const _hoisted_50 = { class: "text-muted mb-2" }
const _hoisted_51 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Catégorie:", -1))
const _hoisted_52 = { class: "text-muted mb-2" }
const _hoisted_53 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Genre:", -1))
const _hoisted_54 = { class: "text-muted" }
const _hoisted_55 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Maison d'édition:", -1))
const _hoisted_56 = {
  key: 0,
  class: "col-md-4 text-center"
}
const _hoisted_57 = ["src", "alt"]
const _hoisted_58 = { class: "card mb-3" }
const _hoisted_59 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "card-header bg-info text-white" }, [
  /*#__PURE__*/_createElementVNode("h6", { class: "mb-0" }, [
    /*#__PURE__*/_createElementVNode("i", { class: "fa fa-calendar me-2" }),
    /*#__PURE__*/_createTextVNode(" Informations de l'emprunt ")
  ])
], -1))
const _hoisted_60 = { class: "card-body" }
const _hoisted_61 = { class: "row" }
const _hoisted_62 = { class: "col-md-6" }
const _hoisted_63 = { class: "mb-3" }
const _hoisted_64 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", { class: "text-muted" }, "Date de début:", -1))
const _hoisted_65 = { class: "fs-5 text-primary" }
const _hoisted_66 = { class: "mb-3" }
const _hoisted_67 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", { class: "text-muted" }, "Date de fin:", -1))
const _hoisted_68 = { class: "fs-5 text-primary" }
const _hoisted_69 = { class: "mb-3" }
const _hoisted_70 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", { class: "text-muted" }, "Statut:", -1))
const _hoisted_71 = { class: "col-md-6" }
const _hoisted_72 = { class: "mb-3" }
const _hoisted_73 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", { class: "text-muted" }, "Date de demande:", -1))
const _hoisted_74 = { class: "fs-6" }
const _hoisted_75 = {
  key: 0,
  class: "mb-3"
}
const _hoisted_76 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", { class: "text-muted" }, "Motif de l'emprunt:", -1))
const _hoisted_77 = { class: "fs-6" }
const _hoisted_78 = {
  key: 1,
  class: "mb-3"
}
const _hoisted_79 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", { class: "text-muted" }, "Jours restants:", -1))
const _hoisted_80 = { class: "fs-6" }
const _hoisted_81 = { class: "card" }
const _hoisted_82 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "card-header bg-success text-white" }, [
  /*#__PURE__*/_createElementVNode("h6", { class: "mb-0" }, [
    /*#__PURE__*/_createElementVNode("i", { class: "fa fa-cogs me-2" }),
    /*#__PURE__*/_createTextVNode(" Actions disponibles ")
  ])
], -1))
const _hoisted_83 = { class: "card-body" }
const _hoisted_84 = { class: "d-flex gap-2 flex-wrap" }
const _hoisted_85 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fa fa-book-open me-1" }, null, -1))
const _hoisted_86 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fa fa-calendar-plus me-1" }, null, -1))
const _hoisted_87 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fa fa-history me-1" }, null, -1))
const _hoisted_88 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fa fa-exclamation-triangle me-1" }, null, -1))
const _hoisted_89 = { class: "modal-footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      (_ctx.loading)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, _hoisted_6))
        : (_ctx.documents.length === 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_7, _hoisted_9))
          : (_openBlock(), _createElementBlock("div", _hoisted_10, [
              _createElementVNode("table", _hoisted_11, [
                _hoisted_12,
                _createElementVNode("tbody", null, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.documents, (emprunt) => {
                    return (_openBlock(), _createElementBlock("tr", {
                      key: emprunt.id
                    }, [
                      _createElementVNode("td", _hoisted_13, [
                        (emprunt.document?.image)
                          ? (_openBlock(), _createElementBlock("img", {
                              key: 0,
                              src: _ctx.getImageUrl(emprunt.document.image),
                              alt: emprunt.document.titre,
                              class: "img-fluid rounded",
                              style: {"width":"50px","height":"50px","object-fit":"cover"},
                              onError: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onImageError && _ctx.onImageError(...args)))
                            }, null, 40, _hoisted_14))
                          : (_openBlock(), _createElementBlock("div", _hoisted_15, _hoisted_17))
                      ]),
                      _createElementVNode("td", null, [
                        _createElementVNode("div", _hoisted_18, _toDisplayString(emprunt.document?.titre || 'Titre non disponible'), 1),
                        _createElementVNode("small", _hoisted_19, _toDisplayString(emprunt.document?.genre?.nom || 'Non défini'), 1)
                      ]),
                      _createElementVNode("td", null, _toDisplayString(emprunt.document?.auteur.nom || 'Auteur non renseigné') + " " + _toDisplayString(emprunt.document?.auteur.prenoms || ''), 1),
                      _createElementVNode("td", null, _toDisplayString(emprunt.document?.categorie?.nom || 'Non classé'), 1),
                      _createElementVNode("td", null, _toDisplayString(_ctx.formatDate(emprunt.dateDebut)), 1),
                      _createElementVNode("td", null, _toDisplayString(_ctx.formatDate(emprunt.dateFin)), 1),
                      _createElementVNode("td", null, [
                        _createElementVNode("span", {
                          class: _normalizeClass([_ctx.getStatutBadgeClass(emprunt.statutEmprunt), "badge"])
                        }, _toDisplayString(_ctx.getStatutLabel(emprunt.statutEmprunt)), 3)
                      ]),
                      _createElementVNode("td", null, [
                        (emprunt.statutEmprunt === 'en_cours')
                          ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                              _createElementVNode("span", {
                                class: _normalizeClass(emprunt.joursRestants <= 3 ? 'text-danger fw-bold' : 'text-success')
                              }, [
                                _hoisted_21,
                                _createTextVNode(" " + _toDisplayString(emprunt.joursRestants > 0 ? 
                                            `${emprunt.joursRestants} jour(s)` : 
                                            'Expire aujourd\'hui'), 1)
                              ], 2)
                            ]))
                          : (emprunt.statutEmprunt === 'en_retard')
                            ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                                _hoisted_23,
                                _createTextVNode(" " + _toDisplayString(Math.abs(emprunt.joursRestants)) + " jour(s) de retard ", 1)
                              ]))
                            : (emprunt.statutEmprunt === 'termine')
                              ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                                  _hoisted_25,
                                  _createTextVNode(" Terminé ")
                                ]))
                              : _createCommentVNode("", true)
                      ]),
                      _createElementVNode("td", _hoisted_26, [
                        (emprunt.statutEmprunt === 'en_cours')
                          ? (_openBlock(), _createElementBlock("button", {
                              key: 0,
                              class: "btn btn-success btn-sm",
                              onClick: ($event: any) => (_ctx.lireDocument(emprunt)),
                              title: "Lire le document"
                            }, [
                              _hoisted_28,
                              _createTextVNode(" Lire ")
                            ], 8, _hoisted_27))
                          : (_openBlock(), _createElementBlock("span", _hoisted_29, [
                              _hoisted_30,
                              _createTextVNode(" Non disponible ")
                            ]))
                      ])
                    ]))
                  }), 128))
                ])
              ])
            ])),
      (_ctx.totalPages > 1)
        ? (_openBlock(), _createElementBlock("nav", _hoisted_31, [
            _createElementVNode("ul", _hoisted_32, [
              _createElementVNode("li", {
                class: _normalizeClass(["page-item", { disabled: _ctx.currentPage <= 1 }])
              }, [
                _createElementVNode("button", {
                  class: "page-link",
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.changerPage(_ctx.currentPage - 1))),
                  disabled: _ctx.currentPage <= 1
                }, " Précédent ", 8, _hoisted_33)
              ], 2),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getPagesArray(), (page) => {
                return (_openBlock(), _createElementBlock("li", {
                  key: page,
                  class: _normalizeClass(["page-item", { active: page === _ctx.currentPage }])
                }, [
                  _createElementVNode("button", {
                    class: "page-link",
                    onClick: ($event: any) => (_ctx.changerPage(page))
                  }, _toDisplayString(page), 9, _hoisted_34)
                ], 2))
              }), 128)),
              _createElementVNode("li", {
                class: _normalizeClass(["page-item", { disabled: _ctx.currentPage >= _ctx.totalPages }])
              }, [
                _createElementVNode("button", {
                  class: "page-link",
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.changerPage(_ctx.currentPage + 1))),
                  disabled: _ctx.currentPage >= _ctx.totalPages
                }, " Suivant ", 8, _hoisted_35)
              ], 2)
            ]),
            _createElementVNode("div", _hoisted_36, " Page " + _toDisplayString(_ctx.currentPage) + " sur " + _toDisplayString(_ctx.totalPages) + " - " + _toDisplayString(_ctx.totalElements) + " résultat(s) au total ", 1)
          ]))
        : _createCommentVNode("", true)
    ]),
    (_ctx.showModalDetails)
      ? (_openBlock(), _createElementBlock("div", _hoisted_37, [
          _createElementVNode("div", _hoisted_38, [
            _createElementVNode("div", _hoisted_39, [
              _createElementVNode("div", _hoisted_40, [
                _hoisted_41,
                _createElementVNode("button", {
                  type: "button",
                  class: "btn-close",
                  onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.fermerModalDetails()))
                })
              ]),
              (_ctx.empruntSelectionne)
                ? (_openBlock(), _createElementBlock("div", _hoisted_42, [
                    _createElementVNode("div", _hoisted_43, [
                      _hoisted_44,
                      _createElementVNode("div", _hoisted_45, [
                        _createElementVNode("div", _hoisted_46, [
                          _createElementVNode("div", _hoisted_47, [
                            _createElementVNode("h5", null, _toDisplayString(_ctx.empruntSelectionne.document?.titre || 'Titre non disponible'), 1),
                            _createElementVNode("p", _hoisted_48, [
                              _hoisted_49,
                              _createTextVNode(" " + _toDisplayString(_ctx.getAuteursNoms(_ctx.empruntSelectionne.document?.auteurs)), 1)
                            ]),
                            _createElementVNode("p", _hoisted_50, [
                              _hoisted_51,
                              _createTextVNode(" " + _toDisplayString(_ctx.empruntSelectionne.document?.categorie?.nom || 'Non classé'), 1)
                            ]),
                            _createElementVNode("p", _hoisted_52, [
                              _hoisted_53,
                              _createTextVNode(" " + _toDisplayString(_ctx.empruntSelectionne.document?.genre?.nom || 'Non défini'), 1)
                            ]),
                            _createElementVNode("p", _hoisted_54, [
                              _hoisted_55,
                              _createTextVNode(" " + _toDisplayString(_ctx.empruntSelectionne.document?.maisonEdition?.nom || 'Non renseigné'), 1)
                            ])
                          ]),
                          (_ctx.empruntSelectionne.document?.image)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_56, [
                                _createElementVNode("img", {
                                  src: _ctx.getImageUrl(_ctx.empruntSelectionne.document.image),
                                  alt: _ctx.empruntSelectionne.document.titre,
                                  class: "img-fluid rounded shadow",
                                  style: {"max-height":"200px","object-fit":"cover"},
                                  onError: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.onImageError && _ctx.onImageError(...args)))
                                }, null, 40, _hoisted_57)
                              ]))
                            : _createCommentVNode("", true)
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_58, [
                      _hoisted_59,
                      _createElementVNode("div", _hoisted_60, [
                        _createElementVNode("div", _hoisted_61, [
                          _createElementVNode("div", _hoisted_62, [
                            _createElementVNode("div", _hoisted_63, [
                              _hoisted_64,
                              _createElementVNode("div", _hoisted_65, _toDisplayString(_ctx.formatDate(_ctx.empruntSelectionne.dateDebut)), 1)
                            ]),
                            _createElementVNode("div", _hoisted_66, [
                              _hoisted_67,
                              _createElementVNode("div", _hoisted_68, _toDisplayString(_ctx.formatDate(_ctx.empruntSelectionne.dateFin)), 1)
                            ]),
                            _createElementVNode("div", _hoisted_69, [
                              _hoisted_70,
                              _createElementVNode("div", null, [
                                _createElementVNode("span", {
                                  class: _normalizeClass([_ctx.getStatutBadgeClass(_ctx.empruntSelectionne.statutEmprunt), "badge fs-6"])
                                }, _toDisplayString(_ctx.getStatutLabel(_ctx.empruntSelectionne.statutEmprunt)), 3)
                              ])
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_71, [
                            _createElementVNode("div", _hoisted_72, [
                              _hoisted_73,
                              _createElementVNode("div", _hoisted_74, _toDisplayString(_ctx.formatDate(_ctx.empruntSelectionne.createdAt)), 1)
                            ]),
                            (_ctx.empruntSelectionne.motif)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_75, [
                                  _hoisted_76,
                                  _createElementVNode("div", _hoisted_77, _toDisplayString(_ctx.empruntSelectionne.motif), 1)
                                ]))
                              : _createCommentVNode("", true),
                            (_ctx.empruntSelectionne.statutEmprunt === 'en_cours')
                              ? (_openBlock(), _createElementBlock("div", _hoisted_78, [
                                  _hoisted_79,
                                  _createElementVNode("div", _hoisted_80, [
                                    _createElementVNode("span", {
                                      class: _normalizeClass(_ctx.empruntSelectionne.joursRestants <= 3 ? 'text-danger' : 'text-success')
                                    }, _toDisplayString(_ctx.empruntSelectionne.joursRestants) + " jour(s) ", 3)
                                  ])
                                ]))
                              : _createCommentVNode("", true)
                          ])
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_81, [
                      _hoisted_82,
                      _createElementVNode("div", _hoisted_83, [
                        _createElementVNode("div", _hoisted_84, [
                          (_ctx.empruntSelectionne.statutEmprunt === 'en_cours')
                            ? (_openBlock(), _createElementBlock("button", {
                                key: 0,
                                class: "btn btn-success",
                                onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.lireDocument(_ctx.empruntSelectionne)))
                              }, [
                                _hoisted_85,
                                _createTextVNode(" Lire le document ")
                              ]))
                            : _createCommentVNode("", true),
                          (_ctx.empruntSelectionne.statutEmprunt === 'en_cours')
                            ? (_openBlock(), _createElementBlock("button", {
                                key: 1,
                                class: "btn btn-outline-primary",
                                onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.prolongerEmprunt(_ctx.empruntSelectionne)))
                              }, [
                                _hoisted_86,
                                _createTextVNode(" Demander une prolongation ")
                              ]))
                            : _createCommentVNode("", true),
                          _createElementVNode("button", {
                            class: "btn btn-outline-info",
                            onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.voirHistorique(_ctx.empruntSelectionne)))
                          }, [
                            _hoisted_87,
                            _createTextVNode(" Voir l'historique ")
                          ]),
                          _createElementVNode("button", {
                            class: "btn btn-outline-warning",
                            onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.signalerProbleme(_ctx.empruntSelectionne)))
                          }, [
                            _hoisted_88,
                            _createTextVNode(" Signaler un problème ")
                          ])
                        ])
                      ])
                    ])
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_89, [
                _createElementVNode("button", {
                  type: "button",
                  class: "btn btn-secondary",
                  onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.fermerModalDetails()))
                }, " Fermer ")
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}